export default __webpack_public_path__ + "assets/EOS_simple_illustration_service_debt_collection.svg";